<template>
  <div>
    <fieldset
      :disabled="isResumeCoordinated"
      style="border: 0; padding: 0; margin: 0;"
    >
    <div class="content-title content-mb-14">
      {{ stepNumber(16) }}. Бюджет проекта в части расходования средств займа и
      средств софинансирования*, тыс. руб.
      <a v-on:click="h16tooltipShow = !h16tooltipShow" class="icon-help"></a>
      <img
        v-on:click="h16tooltipShow = false"
        v-show="h16tooltipShow && !$parent.$parent.modalIsOpened"
        src="https://lkbe.frprf.ru//images/project/p15_info.png"
        style="
            margin-left: 32px;
    margin-top: 20px;
        height: 800px;position: absolute;z-index: 99999"
      />
    </div>
    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <table
          class="c-indicator c-indicator-w-100 table-top-bd"
          v-scroll="handleScroll"
        >
          <thead>
            <tr>
              <th style="width: 80px;">
                № <br />
                п/п
              </th>
              <th style="width: 525px;">
                Направления целевого использования средств
              </th>
              <th colspan="2">
                Зарплата сотрудников, вкл. налоги и взносы от ФОТ
              </th>
              <th colspan="2">
                Работы и услуги, выполняемые третьими лицами, приобретение прав
              </th>
              <th colspan="2">Материалы и комплектующие</th>
              <th colspan="2">Приобретение оборудования</th>
              <th colspan="2">Итого</th>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(articles, index) in project.BUDGET.BUDGET_ARTICLE_ID"
            >
              <tr v-if="articles.length > 1" v-bind:key="index">
                <td>{{ budgetIndex(index) }}</td>
                <td>
                  {{ articles[0].UF_BUDGET_ARTICLE_SECTION_NAME }}
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_ZARPLATA_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_ZARPLATA_SOFIN") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_JOB_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_JOB_SOFIN") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_MATERIAL_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_MATERIAL_SOFIN") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_OBORUD_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_OBORUD_SOFIN") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_ITOGO_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_ITOGO_SOFIN") | toCurrency
                  }}</strong>
                </td>
              </tr>
              <tr
                v-for="(article, articleIndex) in articles"
                v-bind:value="article.UF_BUDGET_ARTICLE_ID"
                v-bind:key="article.UF_BUDGET_ARTICLE_ID"
              >
                <td v-if="articles.length === 1">{{ budgetIndex(index) }}</td>
                <td v-else>{{ budgetIndex(index) }}.{{ articleIndex + 1 }}</td>
                <td v-html="article.UF_BUDGET_ARTICLE_NAME"></td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ZARPLATA_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_ZARPLATA_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_ZARPLATA_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ZARPLATA_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_ZARPLATA_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_ZARPLATA_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_JOB_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_JOB_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_JOB_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_JOB_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_JOB_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_JOB_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_MATERIAL_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_MATERIAL_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_MATERIAL_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_MATERIAL_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_MATERIAL_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_MATERIAL_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_OBORUD_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_OBORUD_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_OBORUD_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_OBORUD_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_OBORUD_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_OBORUD_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ITOGO_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="
                      calcBudgetRowZaim(article.UF_BUDGET_ARTICLE_ID)
                    "
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ITOGO_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="
                      calcBudgetRowSofin(article.UF_BUDGET_ARTICLE_ID)
                    "
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
            </template>
            <tr class="tr-foot-itog">
              <td colspan="2" class="pd-col-62">ИТОГО</td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ZARPLATA_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ZARPLATA_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_JOB_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_JOB_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_MATERIAL_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_MATERIAL_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_OBORUD_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_OBORUD_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ITOGO_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ITOGO_SOFIN') | toCurrency"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <div class="h3-tab-title">
          В том числе распределение по годам, тыс. руб.
        </div>
        <table
          class="c-indicator content-mb-25 c-indicator-w-100 table-top-bd"
          v-scroll="handleScroll"
        >
          <thead>
            <tr>
              <th style="width: 240px;">Год</th>
              <th style="width: 367px;"></th>
              <th colspan="2">
                Зарплата сотрудников, вкл. налоги и взносы от ФОТ
              </th>
              <th colspan="2">
                Работы и услуги, выполняемые третьими лицами, приобретение прав
              </th>
              <th colspan="2">Материалы и комплектующие</th>
              <th colspan="2">Приобретение оборудования</th>
              <th colspan="2">Итого</th>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
              <td class="tab-wid-97">Средства займа</td>
              <td class="tab-wid-111">Средства софинасирования</td>
            </tr>
          </thead>
          <tbody>
            <template v-for="year in budgetYears">
              <tr
                v-if="year !== project.BUDGET_YEAR.YearTwoLine"
                v-bind:key="year"
              >
                <td>{{ year }}</td>
                <td></td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="calcBudgetYearsRowZaim(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="calcBudgetYearsRowSofin(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
              <tr
                v-if="year === project.BUDGET_YEAR.YearTwoLine"
                v-bind:key="year"
              >
                <td>{{ year }} (уже понесенные расходы)</td>
                <td></td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="calcBudgetYearsRowZaim(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="calcBudgetYearsRowSofin(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
              <tr
                :key="yearTwo"
                v-if="year === project.BUDGET_YEAR.YearTwoLine"
              >
                <td>{{ year }} (планируемые расходы)**</td>
                <td></td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][1].UF_ZARPLATA_ZAIM
                    "
                    :disabled="$parent.$parent.projectDisabled"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][1].UF_ZARPLATA_SOFIN
                    "
                    :disabled="$parent.$parent.projectDisabled"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][1].UF_JOB_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="$parent.$parent.projectDisabled"
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][1].UF_JOB_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="$parent.$parent.projectDisabled"
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][1].UF_MATERIAL_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="$parent.$parent.projectDisabled"
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][1].UF_MATERIAL_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="$parent.$parent.projectDisabled"
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][1].UF_OBORUD_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="$parent.$parent.projectDisabled"
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][1].UF_OBORUD_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="$parent.$parent.projectDisabled"
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="calcBudgetYearsRowZaim(year, 1)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="calcBudgetYearsRowSofin(year, 1)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
            </template>
            <tr class="tr-foot-itog">
              <td class="pd-col-62">ИТОГО</td>
              <td></td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ZARPLATA_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ZARPLATA_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_JOB_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_JOB_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_MATERIAL_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_MATERIAL_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_OBORUD_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_OBORUD_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ITOGO_ZAIM') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ITOGO_SOFIN') | toCurrency"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <p class="content-info-text">
          *Заемщиком по столбцу «Средства софинансирования» могут быть учтены
          расходы в проекте, понесенные им в прошлых периодах, но не ранее 2 лет
          до даты подачи Заявки. Данные о понесенных расходах также подлежат
          отражению в соответствующих графах по годам до года заключения
          договора займа<br />**В данном случае
          {{ project.BUDGET_YEAR.YearTwoLine }} год рассматривается как год
          заключения договора займа
        </p>
      </div>
    </div>

    <div class="content-title">
      {{ stepNumber(17) }}. Источники финансирования проекта, включая стадию
      серийного промышленного производства
    </div>
    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <table class="c-indicator content-mb-25 c-indicator-w-100">
          <thead>
            <tr>
              <th class="tab-wid-250 al-text">Форма финансирования</th>
              <th class="tab-wid-250">Источник финансирования</th>
              <th class="tab-wid-550">Страна источника финансирования</th>
              <th class="tab-wid-250">Год расходования средств</th>
              <th class="tab-wid-122 al-text">Сумма, тыс. руб.</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="dc in directory.tree_vid_financing_other_sources">
              <tr v-bind:key="dc.ID">
                <td colspan="3">
                  <strong>{{ dc.NAME }}, из них:</strong>
                </td>
                <td></td>
                <td>
                  <strong>{{
                    calcSourceChildSum(dc.CHILD) | toCurrency
                  }}</strong>
                </td>
                <td></td>
              </tr>
              <template v-for="child in dc.CHILD" v-if="inSourceList(child.ID)">
                <tr
                  v-bind:key="index"
                  v-for="(item, index) in project.OTHER_SOURCE_FINANCE.items"
                  v-if="item.UF_OTHER_SOURCE_ID === child.ID"
                >
                  <td
                    v-bind:class="{
                      'pd-col-42':
                        child.CODE === 'fond' || child.CODE === 'regfond'
                    }"
                    v-if="isFirstSource(item.UF_OTHER_SOURCE_ID, index)"
                  >
                    <a
                      class="add-t-r"
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      v-on:click="addSourceItem(item.UF_OTHER_SOURCE_ID)"
                    ></a>
                    {{ child.NAME }}
                  </td>
                  <td v-else style="text-align: right"></td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_SOURCE'
                      )
                    }"
                  >
                    <input
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      v-model="item.UF_SOURCE"
                      type="text"
                      class="i-main-style"
                      :disabled="$parent.$parent.projectDisabled"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_COUNTRY_ID'
                      )
                    }"
                  >
                    <select
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      v-model="item.UF_COUNTRY_ID"
                      class="i-main-style sel-dropdown"
                      :disabled="
                        child.CODE === 'budget' ||
                          $parent.$parent.projectDisabled
                      "
                      @change="removeOtherSourceFinanceError(index)"
                    >
                      <option
                        v-for="item in directory.country"
                        v-bind:value="item.ID"
                        v-bind:key="item.ID"
                        v-text="item.NAME"
                      ></option>
                    </select>
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(index, 'UF_YEAR')
                    }"
                  >
                    <select
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      v-model="item.UF_YEAR"
                      class="i-main-style sel-dropdown"
                      :disabled="$parent.$parent.projectDisabled"
                      @change="removeOtherSourceFinanceError(index)"
                    >
                      <option
                        v-if="dc.CODE === 'incurred_expenses'"
                        v-for="year in sourcesPastYears"
                        v-bind:key="year"
                        v-text="year"
                      ></option>
                      <option
                        v-if="dc.CODE === 'plan_rashod'"
                        v-for="year in sourcesNextYears"
                        v-bind:key="year"
                        v-text="year"
                      ></option>
                    </select>
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(index, 'UF_VALUE')
                    }"
                  >
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-if="child.CODE === 'fond'"
                      :disabled="
                        child.CODE === 'fond' || $parent.$parent.projectDisabled
                      "
                      v-on:keypress="isNumber($event)"
                      v-model="item.UF_VALUE"
                      type="text"
                      class="i-main-style"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-else-if="child.CODE === 'regfond'"
                      v-model="item.UF_VALUE"
                      :disabled="
                        child.CODE === 'fond' || $parent.$parent.projectDisabled
                      "
                      v-on:keypress="isNumber($event)"
                      v-on:keyup="calcSourceFondValue(item.UF_VALUE)"
                      type="text"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-model="item.UF_VALUE"
                      v-else
                      v-on:keypress="isNumber($event)"
                      type="text"
                      class="i-main-style"
                      :disabled="$parent.$parent.projectDisabled"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                  </td>
                  <td>
                    <a
                      v-on:click="
                        deleteFinSource(index, item.UF_OTHER_SOURCE_ID)
                      "
                      class="link-delete-row"
                    ></a>
                  </td>
                </tr>
              </template>
            </template>
            <tr class="tr-foot-itog">
              <td colspan="4" class="pd-col-62">ИТОГО</td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcSourceSum() | toCurrency"
                  :disabled="$parent.$parent.projectDisabled"
                />
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row myrow content-mb-42" v-show="false">
      <div class="col-xs-12 mycol">
        <form action="#">
          <textarea
            :disabled="$parent.$parent.projectDisabled"
            name=""
            id=""
            class="i-main-style t-dop-style  i-wid-50"
            placeholder="Укажите программу поддержки, в рамках которой получены бюджетные средства, вид поддержки (субсидия, льготный займ и т.п.), а также объем уже израсходованных средств"
          ></textarea>
        </form>
      </div>
    </div>
    </fieldset>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";

export default {
  name: "Budget2",
  props: ["step", "project"],
  data() {
    return {
      loaded: false,
      h16tooltipShow: false,
      h16tooltip:
        "<img src='https://lkbe.frprf.ru/images/project/p15_info.png' />"
    };
  },
  mounted() {
    this.$store
      .dispatch(FETCH_DIRECTORIES, [
        "tree/vid_financing_other_sources",
        "program_fin_support",
        "status_all",
        "status"
      ])
      .then(() => {
        this.$nextTick(this.initializeBudgetData);
      });

    if (typeof this.project.OTHER_SOURCE_FINANCE.items === "undefined") {
      this.project.OTHER_SOURCE_FINANCE.UF_OTHER_SOURCE_ID = [];
      this.project.OTHER_SOURCE_FINANCE.items = [];
    }
  },
  watch: {
    project: {
      handler() {
        this.initializeBudgetData();
      },
      deep: true
    }
  },
  methods: {
    initializeBudgetData() {
      if (this.project && this.project.BUDGET) {
        if (this.project.BUDGET.items.length === 0) {
          this.project.BUDGET.items = new Object();
        }

        for (let articles in this.project.BUDGET.BUDGET_ARTICLE_ID) {
          this.project.BUDGET.BUDGET_ARTICLE_ID[articles].forEach(function(
            item
          ) {
            if (
              typeof this.project.BUDGET.items[item.UF_BUDGET_ARTICLE_ID] ===
              "undefined"
            ) {
              Vue.set(this.project.BUDGET.items, item.UF_BUDGET_ARTICLE_ID, {
                ID: 0,
                UF_BUDGET_ARTICLE_ID: item.UF_BUDGET_ARTICLE_ID,
                UF_ITOGO_SOFIN: 0,
                UF_ITOGO_ZAIM: 0,
                UF_JOB_SOFIN: 0,
                UF_JOB_ZAIM: 0,
                UF_MATERIAL_SOFIN: 0,
                UF_MATERIAL_ZAIM: 0,
                UF_OBORUD_SOFIN: 0,
                UF_OBORUD_ZAIM: 0,
                UF_PROJECT_ID: this.project.ID,
                UF_ZARPLATA_SOFIN: 0,
                UF_ZARPLATA_ZAIM: 0
              });
            }
          },
          this);
        }
        if (
          this.project.BUDGET_YEAR.items[this.project.BUDGET_YEAR.YearTwoLine]
            .length < 2
        ) {
          Vue.set(
            this.project.BUDGET_YEAR.items[
              this.project.BUDGET_YEAR.YearTwoLine
            ],
            1,
            {
              UF_IS_ALREADY: 0,
              UF_ITOGO_SOFIN: 0,
              UF_ITOGO_ZAIM: 0,
              UF_JOB_SOFIN: 0,
              UF_JOB_ZAIM: 0,
              UF_MATERIAL_SOFIN: 0,
              UF_MATERIAL_ZAIM: 0,
              UF_OBORUD_SOFIN: 0,
              UF_OBORUD_ZAIM: 0,
              UF_PROJECT_ID: this.project.ID,
              UF_YEAR: this.project.BUDGET_YEAR.YearTwoLine,
              UF_ZARPLATA_SOFIN: 0,
              UF_ZARPLATA_ZAIM: 0
            }
          );
        }

        this.$store.dispatch(FETCH_DIRECTORY, ["country"]).then(() => {
          const ruid = this.findRussia();

          this.project.OTHER_SOURCE_FINANCE.UF_OTHER_SOURCE_ID.forEach(function(
            sourceId
          ) {
            let n = false;
            this.project.OTHER_SOURCE_FINANCE.items.forEach(function(item) {
              if (sourceId == item.UF_OTHER_SOURCE_ID) {
                n = true;
              }
            }, this);
            if (!n) {
              this.project.OTHER_SOURCE_FINANCE.items.push({
                UF_COUNTRY_ID: ruid,
                UF_OTHER_SOURCE_ID: sourceId,
                UF_PROJECT_ID: this.project.ID,
                UF_SOURCE: "",
                UF_TARGET: "",
                UF_VALUE: "",
                UF_YEAR: ""
              });
            }
          },
          this);

          this.directory.tree_vid_financing_other_sources[1].CHILD.forEach(
            function(s) {
              let ss = 0;
              if (s.CODE === "regfond") {
                this.project.OTHER_SOURCE_FINANCE.items.forEach(function(item) {
                  if (s.ID == item.UF_OTHER_SOURCE_ID) {
                    ss = item.UF_VALUE;
                  }
                }, this);
              }
              this.calcSourceFondValue(ss);
            },
            this
          );
        }, this);
      }
      this.loaded = true;
    },
    stepNumber(num) {
      let steps = {
        16: 17,
        17: 18
      };

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "konversia" &&
        this.project.UF_VERSION === 1
      ) {
        steps = {
          16: 16,
          17: 17
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "konversia" &&
        this.project.UF_VERSION >= 2
      ) {
        if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1) {
          steps = {
            16: 18,
            17: 19
          };
        } else {
          steps = {
            16: 17,
            17: 18
          };
        }
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
          "complectyushie" ||
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
          "complectyushie_rfrp"
      ) {
        steps = {
          16: 17,
          17: 18
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
          "complectyushie_rfrp" ||
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "complectyushie"
      ) {
        steps = {
          16: 18,
          17: 19
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "working" &&
        this.project.UF_INDICATOR_VERSION === 1
      ) {
        steps = {
          16: 17,
          17: 18
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "working" &&
        this.project.UF_INDICATOR_VERSION !== 1
      ) {
        steps = {
          16: 19,
          17: 20
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "working_rfrp"
      ) {
        steps = {
          16: 18,
          17: 19
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
        "stankostroi" /*||
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "konversia"*/
      ) {
        if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1) {
          steps = {
            16: 18,
            17: 19
          };
        } else {
          steps = {
            16: 17,
            17: 18
          };
        }
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "priority_program"
      ) {
        if (this.project.UF_PRIORITY_PROJECT_VERSION == 3) {
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1) {
            steps = {
              16: 25,
              17: 26
            };
          } else {
            steps = {
              16: 24,
              17: 25
            };
          }
        } else {
          if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1) {
            steps = {
              16: 26,
              17: 27
            };
          } else {
            steps = {
              16: 25,
              17: 26
            };
          }
        }
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "evolution" &&
        this.project.UF_VERSION < 3 &&
        !this.project.UF_INDICATOR_VERSION !== 1
      ) {
        steps = {
          16: 17,
          17: 18
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "evolution" &&
        this.project.UF_VERSION > 2 &&
        !this.project.UF_INDICATOR_VERSION !== 1
      ) {
        steps = {
          16: 17,
          17: 18
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "auto_components"
      ) {
        steps = {
          16: 18,
          17: 19
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "regfond" &&
        this.project.UF_VERSION > 2
      ) {
        steps = {
          16: 18,
          17: 19
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
        "improving_ecology"
      ) {
        steps = {
          16: 17,
          17: 18
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "cifrovizaciya"
      ) {
        steps = {
          16: 20,
          17: 21
        };
      }

      return steps[num] + (this.project.UF_SETTING && this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1 ? 1 : 0);
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID == id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    },
    hasBudgetError(id, field) {
      if (typeof this.$parent.$parent.budgetErrors[id] !== "undefined") {
        if (
          typeof this.$parent.$parent.budgetErrors[id][field] !== "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    removeBudgetError(id) {
      if (typeof this.$parent.$parent.budgetErrors[id] !== "undefined") {
        Vue.delete(this.$parent.$parent.budgetErrors, id);
      }
      return false;
    },
    hasOtherSourceFinanceError(id, field) {
      if (
        typeof this.$parent.$parent.otherSourceFinanceErrors[id] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.otherSourceFinanceErrors[id][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    removeOtherSourceFinanceError(id) {
      if (
        typeof this.$parent.$parent.otherSourceFinanceErrors[id] !== "undefined"
      ) {
        Vue.delete(this.$parent.$parent.otherSourceFinanceErrors, id);
      }
      return false;
    },
    calcSourceFondValue(sum) {
      this.directory.tree_vid_financing_other_sources[1].CHILD.forEach(function(
        s
      ) {
        if (s.CODE == "fond") {
          this.project.OTHER_SOURCE_FINANCE.items.forEach(function(item) {
            if (s.ID == item.UF_OTHER_SOURCE_ID) {
              item.UF_VALUE = this.project.UF_SUM_REQUEST - sum;
              if (item.UF_VALUE < 0) item.UF_VALUE = 0;
            }
          }, this);
        }
      },
      this);
    },
    findRussia() {
      let id = 0;

      this.directory.country.forEach(function(country) {
        if (country.CODE == "ru") {
          id = country.ID;
        }
      });

      return id;
    },
    inSourceList(sourceId) {
      let n = false;
      this.project.OTHER_SOURCE_FINANCE.UF_OTHER_SOURCE_ID.forEach(function(
        id
      ) {
        if (sourceId == id) {
          n = true;
        }
      },
      this);
      return n;
    },
    isFirstSource(sourceId, index) {
      let sd = null;
      this.project.OTHER_SOURCE_FINANCE.items.forEach(function(item, k) {
        if (sourceId == item.UF_OTHER_SOURCE_ID && sd === null) {
          sd = k;
        }
      }, this);
      return sd === index;
    },
    addSourceItem(sourceId) {
      this.project.OTHER_SOURCE_FINANCE.items.push({
        UF_COUNTRY_ID: this.findRussia(),
        UF_OTHER_SOURCE_ID: sourceId,
        UF_PROJECT_ID: this.project.ID,
        UF_SOURCE: "",
        UF_TARGET: "",
        UF_VALUE: "",
        UF_YEAR: ""
      });
    },
    calcSourceSum() {
      let sum = 0;
      this.project.OTHER_SOURCE_FINANCE.items.forEach(function(item) {
        let s = parseInt(item.UF_VALUE);
        if (s > 0) {
          sum += s;
        }
      }, this);
      return sum;
    },
    calcSourceChildSum(childs) {
      let sum = 0;
      childs.forEach(function(child) {
        this.project.OTHER_SOURCE_FINANCE.items.forEach(function(item) {
          if (child.ID == item.UF_OTHER_SOURCE_ID) {
            let s = parseInt(item.UF_VALUE);
            if (s > 0) {
              sum += s;
            }
          }
        }, this);
      }, this);
      return sum;
    },
    calcBudgetRowZaim(item) {
      let i = this.project.BUDGET.items[item];
      if (i.UF_ZARPLATA_ZAIM === "") i.UF_ZARPLATA_ZAIM = 0;
      if (i.UF_JOB_ZAIM === "") i.UF_JOB_ZAIM = 0;
      if (i.UF_MATERIAL_ZAIM === "") i.UF_MATERIAL_ZAIM = 0;
      if (i.UF_OBORUD_ZAIM === "") i.UF_OBORUD_ZAIM = 0;
      let sum =
        parseInt(i.UF_ZARPLATA_ZAIM) +
        parseInt(i.UF_JOB_ZAIM) +
        parseInt(i.UF_MATERIAL_ZAIM) +
        parseInt(i.UF_OBORUD_ZAIM);

      this.project.BUDGET.items[item].UF_ITOGO_ZAIM = sum;
      return sum;
    },
    calcBudgetRowSofin(item) {
      let i = this.project.BUDGET.items[item];
      if (i.UF_ZARPLATA_SOFIN === "") i.UF_ZARPLATA_SOFIN = 0;
      if (i.UF_JOB_SOFIN === "") i.UF_JOB_SOFIN = 0;
      if (i.UF_MATERIAL_SOFIN === "") i.UF_MATERIAL_SOFIN = 0;
      if (i.UF_OBORUD_SOFIN === "") i.UF_OBORUD_SOFIN = 0;
      let sum =
        parseInt(i.UF_ZARPLATA_SOFIN) +
        parseInt(i.UF_JOB_SOFIN) +
        parseInt(i.UF_MATERIAL_SOFIN) +
        parseInt(i.UF_OBORUD_SOFIN);

      this.project.BUDGET.items[item].UF_ITOGO_SOFIN = sum;
      return sum;
    },
    calcBudgetYearsRowZaim(item, k) {
      let i = this.project.BUDGET_YEAR.items[item][k];
      let sum =
        parseInt(i.UF_ZARPLATA_ZAIM) +
        parseInt(i.UF_JOB_ZAIM) +
        parseInt(i.UF_MATERIAL_ZAIM) +
        parseInt(i.UF_OBORUD_ZAIM);

      this.project.BUDGET_YEAR.items[item][k].UF_ITOGO_ZAIM = sum;
      return sum;
    },
    calcBudgetYearsRowSofin(item, k) {
      let i = this.project.BUDGET_YEAR.items[item][k];
      let sum =
        parseInt(i.UF_ZARPLATA_SOFIN) +
        parseInt(i.UF_JOB_SOFIN) +
        parseInt(i.UF_MATERIAL_SOFIN) +
        parseInt(i.UF_OBORUD_SOFIN);

      this.project.BUDGET_YEAR.items[item][k].UF_ITOGO_SOFIN = sum;
      return sum;
    },
    calcBudgetSum(field) {
      let sum = 0;
      Object.keys(this.project.BUDGET.items).map(function(objectKey) {
        sum += parseInt(this.project.BUDGET.items[objectKey][field]);
      }, this);
      return sum;
    },
    calcBudgetYearsSum(field) {
      let sum = 0;
      Object.keys(this.project.BUDGET_YEAR.items).map(function(objectKey) {
        sum += parseInt(this.project.BUDGET_YEAR.items[objectKey][0][field]);
        if (this.project.BUDGET_YEAR.items[objectKey].length > 1) {
          sum += parseInt(this.project.BUDGET_YEAR.items[objectKey][1][field]);
        }
      }, this);
      return sum;
    },
    calcArticlesSum(articles, field) {
      let sum = 0;
      articles.forEach(function(article) {
        sum += parseInt(
          this.project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID][field]
        );
      }, this);
      return sum;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    budgetIndex(i) {
      let budgetIndex;
      let k = Object.keys(this.project.BUDGET.BUDGET_ARTICLE_ID);
      for (budgetIndex = 0; budgetIndex < k.length; budgetIndex++) {
        if (k[budgetIndex] == i) {
          break;
        }
      }
      return budgetIndex + 1;
    },
    deleteFinSource(index, id) {
      this.project.OTHER_SOURCE_FINANCE.items.splice(index, 1);
      let t = this.project.OTHER_SOURCE_FINANCE.items.filter(
        c => c.UF_OTHER_SOURCE_ID === id
      );
      if (t.length === 0) {
        const ruid = this.findRussia();
        this.project.OTHER_SOURCE_FINANCE.items.push({
          UF_COUNTRY_ID: ruid,
          UF_OTHER_SOURCE_ID: id,
          UF_PROJECT_ID: this.project.ID,
          UF_SOURCE: "",
          UF_TARGET: "",
          UF_VALUE: "",
          UF_YEAR: ""
        });
      }
    },
    handleScroll: function(evt, el) {
      if (window.scrollY > 100) {
        if (el.classList.contains("table-top-bd")) {
          el.classList.add("table-top-bd_fix");
        }
      } else {
        if (el.classList.contains("table-top-bd")) {
          el.classList.remove("table-top-bd_fix");
        }
      }
    }
  },
  directives: {
    scroll: {
      // определение директивы
      inserted: function(el, binding) {
        let f = function(evt) {
          if (binding.value(evt, el)) {
            window.removeEventListener("scroll", f);
          }
        };
        window.addEventListener("scroll", f);
      }
    }
  },
  computed: {
    yearTwo() {
      return "x" + this.project.BUDGET_YEAR.YearTwoLine;
    },
    sourcesPastYears() {
      let years = [];
      for (
        let i = this.project.OTHER_SOURCE_FINANCE.yearStart;
        i <= this.project.OTHER_SOURCE_FINANCE.dataTwoYear;
        i++
      ) {
        years.push(i);
      }
      return years;
    },
    sourcesNextYears() {
      let years = [];
      for (
        let i = this.project.OTHER_SOURCE_FINANCE.dataTwoYear;
        i <= this.project.OTHER_SOURCE_FINANCE.yearEnd;
        i++
      ) {
        years.push(i);
      }
      return years;
    },
    budgetYears() {
      let years = [];
      for (
        let i = this.project.BUDGET_YEAR.yearStart;
        i <= this.project.BUDGET_YEAR.yearEnd;
        i++
      ) {
        years.push(i);
      }
      return years;
    },
    isResumeCoordinated() {
      const list = this.project && this.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          el.UF_TYPE_PAGE === "rezume_10_01" &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    },
    ...mapGetters(["directory"])
  }
};
</script>
